export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const FORGOT_PASSWORD = "forgotPassword";
export const RESTORE_PASSWORD = "restorePassword";
export const CHANGE_PASSWORD = "changePassword";
export const UPDATE_USER = "updateUser";
export const SESSIONS = "sessions";
export const CLOSE_SESSION = "closeSessions";
export const FETCH_USER_DATA = "fetcUserData";

export const GET_PRODUCTS = "getProduct";
export const SEARCH_PRODUCTS = "searchProduct";
export const CREATE_PRODUCT = "createProduct";
export const ADD_INVENTORY = "addInventory";
export const SELL_PRODUCT = "sellProduct";

export const FETCH_COMMERCES_TYPES = "fetchCommercersTypes";
export const FETCH_PROBLEMS_TYPES = "fetchProblemTypes";
export const CREATE_TICKET = "createTicket";
export const DATA_USER = "dataUser";

export const FETCH_STATES = "fetchStates";
export const FETCH_CITIES = "fetchCities";
////////////// PRODUCTS ////////////////////
export const FETCH_PRODUCTS = "fetchProducts";
export const FETCH_CATEGORIES = "fetchCategories";
export const CREATE_CATEGORY = "createCategory";
export const SAVE_PRODUCTS = "saveProducts";
export const SELL_PRODUCTS = "sellProducts";
export const FETCH_SNR_OFFICES = "snrOffices";
export const QUERY_PRODUCTS = "queryProduct";
export const FETCH_TRANSACTIONS = "fetchTransactions";
export const TRANSACTION_PACKAGE = "transactionPackage";
export const CARRIERS = "fetchCarriers";
export const PACKAGES = "fetchPackages";
export const DOWNLOAD_CARNET = "downloadCarnet";
////////////// CUSTOMERS ////////////////////
export const FETCH_CUSTOMERS = "fetchCustomers";
export const CREATE_CUSTOMER = "createCustomer";
export const DELETE_CUSTOMER = "deleteCustomer";
export const UPDATE_CUSTOMER = "updateCustomer";
export const SEARCH_CUSTOMER = "searchCustomer";
export const PAY_DEBT = "payDebt";

////////////// TICKETS ////////////////////
export const CREATE_CONTACT = "createContact";

////////////// REPORTS ////////////////////
 
export const FETCH_REPORT_GENERATE = "fetchReportGenerate";
export const FETCH_CASHFLOWS = "fetchCashflows";
export const CREATE_CASHFLOW = "createCashflow";





// WEBPACK FOOTER //
// ./src/store/actions.type.js